import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
// Statik HTML'deki canonical'ı React/Helmet head'i değiştirmeden ÖNCE yakala
// (prerender edilmiş sayfalarda yanlış noindex basılmasını önlemek için).
import "./lib/prerenderFlag";
import { cleanupLegacyServiceWorkers, installImageRetry } from "./lib/resilience";

cleanupLegacyServiceWorkers();
installImageRetry();

createRoot(document.getElementById("root")!).render(<App />);
